import {
  Required,
  IsString,
  IsNumber,
  DataValidator,
  transformKeys,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

interface SidebarFolderProjectsParams {
  workspace_id: string;
  folder_id: string;
  current_page?: number;
  page_size?: number;
}

interface SidebarFolderProjectsProps {
  workspaceId: string,
  folderId: string,
  currentPage: number,
  pageSize: number,
}

// 原始接口
interface SidebarFolderProjectsResponse {
  current_num: number;
  total_page: number;
  total_pro: number;
  projects: {
    folder_id: string;
    id: string;
    name: string;
    sort_order: number;
    created_at: number;
    latest_video_image?: string;
  }[];
}

class Project {
  @Required("Folder ID cannot be empty")
  @IsString("Folder ID must be a string")
  folderId: string;

  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Sort order cannot be empty")
  @IsNumber("Sort order must be a number")
  sortOrder: number;

  @Required("Created at cannot be empty")
  @IsString("Created at must be a number")
  createdAt: string;

  latestVideoImage?: string;
}

// 主数据类
export class SidebarFolderProjectsData {
  @Required("Current num cannot be empty")
  @IsNumber("Current num must be a number")
  currentNum: number;

  @Required("Total page cannot be empty")
  @IsNumber("Total page must be a number")
  totalPage: number;

  @Required("Total pro cannot be empty")
  @IsNumber("Total pro must be a number")
  totalPro: number;

  @Required("Projects cannot be empty")
  @IsArray("Projects must be an array")
  @ValidateNested(Project)
  projects: Project[];
}

const transformAndValidateSidebarFolderProjects = (
  response: SidebarFolderProjectsResponse
): SidebarFolderProjectsData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, SidebarFolderProjectsData);
  } catch (error) {
    console.error("Sidebar folder projects data validation failed:", error.message);
    throw error;
  }
};

// 获取文件夹下项目
export const sidebarFolderProjects = async (props: SidebarFolderProjectsProps): Promise<SidebarFolderProjectsData> => {
  const params: SidebarFolderProjectsParams = {
    workspace_id: props.workspaceId,
    folder_id: props.folderId,
    current_page: props.currentPage,
    page_size: props.pageSize,
  };
  const res = await api.post<SidebarFolderProjectsResponse>("/sidebar/folder/projects", params);
  const validatedData = transformAndValidateSidebarFolderProjects(res.data);
  return validatedData;
};
